import {Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef} from '@angular/core';
import {Store} from '@ngrx/store';
import {filter, tap} from 'rxjs/operators';

import {AuthenticatedUserService} from '../../service/authenticated-user.service';
import {State} from '@app/app.reducers';

@Directive({
    selector: '[hasRole]'
})
export class CanAccessDirective implements OnInit, OnDestroy {

    @Input('hasRole') permRoles: string[];
    @Input() hasRoleOrgTypes: string[] = null;

    // private user$: Subscription;

    constructor(private templateRef: TemplateRef<any>,
                private viewContainer: ViewContainerRef,
                private authenticatedUserService: AuthenticatedUserService,
                private store: Store<State>
    ) {
    }

    ngOnInit(): void {
        /* this.user$ = this.store.pipe(select(getAuthenticatedUser))
            .subscribe(user => {
                this.applyPermission(this.authenticatedUserService.doCheckAuthorization(user, this.permRoles));
            });*/

        if (this.hasRoleOrgTypes === null) {
            // Check role org type by default (if no orgTypes was provided)
            this.hasRoleOrgTypes = this.authenticatedUserService.getRolesOrgTypes(this.permRoles);
        }

        this.authenticatedUserService.hasRole(this.permRoles, this.hasRoleOrgTypes)
            .pipe(
                tap(() => this.viewContainer.clear()),
                filter(result => result)
            )
            .subscribe(() =>
                this.viewContainer.createEmbeddedView(this.templateRef)
            );
    }

    ngOnDestroy(): void {
        // this.user$.unsubscribe();
    }
}
